<div class="wrap">
  <button *ngIf="!isLoadingZipAllOffers" matTooltip="Télécharger les images principales de chaque article"
    (click)="downloadAllMainPicturesFromOffers()" appChangeColorTheme attribute="bgc" class="donwloadBtn">
    <fa-icon [icon]="getFaIcon('faDownload')"></fa-icon>
    Télécharger images
  </button>

  <mat-spinner class="spinnerZipAllOffers" *ngIf="isLoadingZipAllOffers" [diameter]="30" color="primary"></mat-spinner>

  <div class="table">
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

      <ng-container matColumnDef="offerKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="offerKey">N° de l'article</th>
        <td mat-cell *matCellDef="let element"> {{element.offerKey}}</td>
      </ng-container>

      <ng-container matColumnDef="offreNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="offreNom" class="cell_text">Nom de l'article</th>
        <td mat-cell *matCellDef="let element" class="cell_text"> {{element.offerName}} </td>
      </ng-container>

      <ng-container matColumnDef="articleType">
        <th mat-header-cell *matHeaderCellDef class="cell_text">Type de l'article</th>
        <td mat-cell *matCellDef="let element" class="cell_text"> {{ element.universes ? element.universes[0].universeName : null }} </td>
      </ng-container>

      <ng-container matColumnDef="clubNom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="clubNom" class="cell_club">Acteur</th>
        <td mat-cell *matCellDef="let element" class="cell_club">{{element.clubCode}}</td>
      </ng-container>

      <ng-container matColumnDef="rating">
        <th mat-header-cell mat-sort-header="rating" *matHeaderCellDef> Note </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ratingTotal > 0">{{element.rating}}
            <sup *ngIf="element.ratingTotal > 1">
              <fa-icon class="faInfoCircle" [icon]="getFaIcon('faInfoCircle')"
                [matTooltip]="'Moyenne des ' + element.ratingTotal + ' notes réalisées par les utilisateurs de l\'activité'"
                appChangeColorTheme attribute="color"></fa-icon>
            </sup>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="action_container">
        <th mat-header-cell *matHeaderCellDef class="actions"></th>
        <td mat-cell *matCellDef="let element" class="actions">
          <div class="actions-content">
            <button mat-icon-button matTooltip="Éditer" matTooltipPosition="above" (click)="$event.preventDefault(); editOffer(element)">
              <mat-icon>edit</mat-icon>
            </button>
            <mat-slide-toggle matTooltip="Activer/Désactiver" matTooltipPosition="above" size="large" (toggleChange)="isActivatedOrDeactivated(element)" [color]="color"
              [checked]="element?.isActive"></mat-slide-toggle>

            <ng-container *ngIf="element.formDefinitionKey; else noFormDefTemplate">
              <button mat-icon-button (click)="onGetListSubscriptions(element)" matTooltip="Afficher la liste des participants" matTooltipPosition="above">
                <mat-icon>person</mat-icon>
              </button>
            </ng-container>
            <ng-template #noFormDefTemplate>
              <button mat-icon-button disabled (click)="onGetListSubscriptions(element)">
                <mat-icon>person</mat-icon>
              </button>
            </ng-template>


            <button mat-icon-button matTooltip="Menu image" matTooltipPosition="above" (click)="offerPreviewUpdate.next(element)" [matMenuTriggerFor]="menu">
              <mat-icon>upload</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngIf="!isLoadingZipOneOffer"
                (click)="downloadImagesFromOneOffer(element)">Télécharger les images de cet article</button>
              <mat-spinner *ngIf="isLoadingZipOneOffer" [diameter]="30" color="primary"></mat-spinner>
              <p class="subTitleMenu"><b>Image principale</b></p>
              <hr class="horizontalLine">
              <button mat-menu-item (click)="openDialogChooseImageFromClub(element)">
                <!-- Importer une image du club -->
                <span>Importer une image de l'acteur</span>
              </button>
              <button mat-menu-item (click)="openDialogImportImage(element)">Importer une nouvelle image</button>
            </mat-menu>

            <button mat-icon-button matTooltip="Autres actions" matTooltipPosition="above" [matMenuTriggerFor]="other_menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #other_menu="matMenu">
              <button mat-menu-item (click)="uploadFormDetails(element)">
                <mat-icon>upload</mat-icon>
                <span>Exporter les souscriptions</span>
              </button>
              <button mat-menu-item (click)="goToFilesOffer(element)" matTooltip="{{ getTooltip('goToFilesOffer') }}" matTooltipPosition="above">
                <mat-icon>insert_drive_file</mat-icon>
                <span>{{ getTooltip('goToFilesOffer') }}</span>
              </button>
              <button mat-menu-item (click)="changePreview(element)">
                <mat-icon>image</mat-icon>
                <span>{{ getTooltip('showPreview') }}</span>
              </button>
              <button mat-menu-item (click)="duplicateOffer(element)">
                <mat-icon>content_copy</mat-icon>
                <span>{{ getTooltip('duplicateOffer') }}</span>
              </button>
              <button mat-menu-item (click)="copyString(element.offerKey)">
                <mat-icon>link</mat-icon>
                <span>Copier le lien de l'offre</span>
              </button>
            </mat-menu>
          </div>
        </td>

      </ng-container>

      <!-- <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Éditer </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <button mat-icon-button (click)="$event.preventDefault(); editOffer(element)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="isActive">
        <th mat-header-cell mat-sort-header="isActive" *matHeaderCellDef class="cell_IsActive"
          [style.text-align]="'right !important'"> Act./Dés. </th>
        <td mat-cell *matCellDef="let element" class="cell_IsActive">
          <mat-slide-toggle size="large" (toggleChange)="isActivatedOrDeactivated(element)" [color]="color"
            [checked]="element?.isActive"></mat-slide-toggle>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="editImage">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Image </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <button mat-icon-button matTooltip="Menu image" (click)="offerPreviewUpdate.next(element)" [matMenuTriggerFor]="menu">
            <mat-icon>upload</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="!isLoadingZipOneOffer"
              (click)="downloadImagesFromOneOffer(element)">Télécharger les images de cet article</button>
            <mat-spinner *ngIf="isLoadingZipOneOffer" [diameter]="30" color="primary"></mat-spinner>
            <p class="subTitleMenu"><b>Image principale</b></p>
            <hr class="horizontalLine">
            <button mat-menu-item (click)="openDialogChooseImageFromClub(element)">
              <span>Importer une image de l'acteur</span>
            </button>
            <button mat-menu-item (click)="openDialogImportImage(element)">Importer une nouvelle image</button>
          </mat-menu>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="file">
        <th mat-header-cell *matHeaderCellDef class="cell_session">Fichiers</th>
        <td mat-cell *matCellDef="let element" class="cell_session">
          <button mat-icon-button (click)="goToFilesOffer(element)" [matTooltip]="getTooltip('goToFilesOffer')">
            <mat-icon>insert_drive_file</mat-icon>
          </button>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="otherActions">
        <th mat-header-cell *matHeaderCellDef class="cell_action"></th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <button mat-icon-button matTooltip="Autres actions" [matMenuTriggerFor]="other_menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #other_menu="matMenu">
            <button mat-icon-button (click)="changePreview(element)" [matTooltip]="getTooltip('showPreview')">
              <mat-icon>image</mat-icon>
            </button>
            <button mat-icon-button (click)="duplicateOffer(element)" [matTooltip]="getTooltip('duplicateOffer')">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button (click)="copyString(element.offerKey)" [matTooltip]="'Copier le lien de l\'offre'">
              <mat-icon>link</mat-icon>
            </button>
          </mat-menu>
        </td>
      </ng-container> -->



      <!-- <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Aperçu </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faImage')" [matTooltip]="getTooltip('showPreview')"
            (click)="changePreview(element)" appChangeColorTheme attribute="color">
          </fa-icon>
        </td>
      </ng-container> -->




      <!-- <ng-container matColumnDef="duplicate">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Dupliquer </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faCopy')" (click)="duplicateOffer(element)"
            [matTooltip]="getTooltip('duplicateOffer')" appChangeColorTheme attribute="color">
          </fa-icon>
        </td>
      </ng-container> -->

      <!-- <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Lien </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          <fa-icon [icon]="getFaIcon('faLink')" [matTooltip]="'Copier le lien de l\'offre'"
            (click)="copyString(element.offerKey)" appChangeColorTheme attribute="color"></fa-icon>
        </td>
      </ng-container> -->





      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="pageEvent = $event" [color]="color">
    </mat-paginator>
  </div>

  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
</div>
